// DebaterTeamInfo.jsx
import React, { useState, useEffect } from 'react';
import styles from './DebaterTeamInfo.module.css';
import avatar from './../../../assets/default-avatar.svg';
import { useTranslation } from 'react-i18next';
import { SpeakerphoneIcon, AcademicCapIcon, StarIcon } from '@heroicons/react/solid';
import { useAuth } from "../../../utils/AuthContext/authcontext";


const DebaterTeamInfo = ({ isWinning, teamName, currentUserUid, debaters = [], scores = {}, speakingUids = [], isSingleTeam = false, isActive = false }) => {
  const { t } = useTranslation();
	const [getDebaters, setDebaters] = useState(debaters);
  const { userData, searchbyUsersId } = useAuth();

  //console.log(isActive, teamName, speakingUids);
  const enrichMessagesWithUser = async (debaters) =>  {
	const cache = {};

	return Promise.all(
		debaters.map(async (debater) => {
		if (!cache[debater.uid]) {
			cache[debater.uid] = await searchbyUsersId(debater.uid);
      debater.profilePicture = cache[debater.uid]?.[0]?.profilePicture;
      debater.username = cache[debater.uid]?.[0]?.username;
		}

		return {
			...debater,
			user: cache[debater.uid],
		};
		})
	);
	}

	useEffect(() => {
	const process = async () => {
		if (!debaters) return;
		const enriched = await enrichMessagesWithUser(debaters);
		setDebaters(enriched);
	};

	process();
	}, [debaters]);

  const totalScore = () => {
    var score = getDebaters.reduce((total, debater) => total + (scores[debater.uid] || 0), 0);
    return score;
  }

  return (
  <div className={`${styles.teamInfo} ${isActive ? styles.active : ''}`}>
    <div className={styles.teamFooter}><h2 className={styles.teamHeader}><span className={styles.teamname}>Team {teamName.toUpperCase()}</span></h2>{totalScore !== undefined && <div className={styles.teamScorediv}><div className={`${styles.teamScoreWinning} ${isWinning ? styles.teamWinning : styles.teamNotWinning}`}><StarIcon /></div><h1 className={styles.teamScoreh1}>{totalScore()}</h1></div>}</div>
    {getDebaters.length === 0 && <p className={styles.noOne}>{t('ui.noBebaters')}</p>}
    {getDebaters.map(member => {
      if (!member?.uid) return null;
      const isSpeaking = speakingUids.includes(member.uid);
      const score = scores[member.uid] ?? 0; // placeholder
      return (
        <div key={member.uid} className={`${styles.member} ${isSpeaking ? styles.memberSpeaking : ''}`}>
          <img
            src={member.profilePicture || avatar}
            alt={member.username || 'Debater'}
            className={currentUserUid === member.uid ? `${styles.avatar} ${styles.you}` :  styles.avatar}/>
          <div className={styles.info}>
            <span className={styles.username}>{member.username || 'Anonymous'}</span>
            {isSingleTeam == false ? <span className={styles.details}>
              {/*Score: {score}*/} {isSpeaking && <div className={styles.waveform}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>}
            </span> : <span className={styles.details}>
              {isSpeaking && <div className={styles.waveform}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>}
            </span>}
          </div>
        </div>
      );
    })}
  </div>
  );
};

export default DebaterTeamInfo;
